<script>
  import { areaView } from "/guidebook/shared/urls";

  export let endpoint;
  export let areaSlug = null;
  export let businessCode = null;
</script>

{#if areaSlug || businessCode}
  {#await endpoint then { data }}
    <ul class="list-inline mb-0">
      {#each data.results as area, i}
        <li class="list-inline-item">
          <a href={areaView(area.country.code, area.slug)}>{area.name}</a>
          <!-- only add dots inbetween area links -->
          {#if i < data.results.length - 1}
            <i class="bi bi-dot" />
          {/if}
        </li>
      {/each}
    </ul>
  {/await}
{/if}
